namespace $ {

	$mol_style_define( $bog_ui_app_command, {

		padding: $mol_gap.block,

		Description: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Open_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '.5rem',
				bottom: '.75rem',
			},
		},

		Open_row: {
			display: 'flex',
			gap: '.75rem',
			flex: {
				wrap: 'wrap',
			},
			align: {
				items: 'center',
			},
			padding: {
				bottom: '1.5rem',
			},
		},

		Shortcut_hint: {
			color: $mol_theme.shade,
			font: {
				size: '0.875rem',
			},
		},

		Groups_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				bottom: '.75rem',
			},
		},

		Groups_desc: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

	} )

}
